import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

export default function ProgressBar({ currentStep, totalSteps }) {
  const { t } = useTranslation()
  const progress = Math.max(0, Math.min(1, currentStep / totalSteps))

  console.log('progress', progress)

  return (
    <div className='flex flex-row items-center'>
      <span className='text-sm font-bold text-primaryBlue'>
        {t('discover.create_career.step', { currentStep, totalSteps })}
      </span>
      <div className='ml-4 h-1.5 w-36 overflow-hidden rounded-full bg-softGrey'>
        <div
          className='h-full bg-primaryGreen transition-all duration-300'
          style={{ width: `${progress === 1 ? 80 : progress * 100}%` }}
        />
      </div>
    </div>
  )
}

ProgressBar.propTypes = {
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired
}
